import { Link, LinkText } from '../Link';
import { QuickLinkItem } from './QuickLinkItem';

export interface IQuickLinkPhoneProps {
	title: string;
	number: string;
}

export function QuickLinkPhone({ title, number }: IQuickLinkPhoneProps) {
	return (
		<QuickLinkItem>
			<Link href={`tel:${number}`}>
				<LinkText>{title}</LinkText>
			</Link>
		</QuickLinkItem>
	);
}
